import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TicketService, CustomerTicketSummary, GameTicketQuery } from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgbcl-games-list-with-tickets',
  templateUrl: './games-list-with-tickets.component.html',
  styleUrls: ['./games-list-with-tickets.component.scss'],
})
export class GamesListWithTicketsComponent implements OnInit {
  games$: Observable<CustomerTicketSummary[] | undefined>;
  @Input() filters: any[] | undefined;
  @Input() sortOptions: any[] | undefined;
  @Output() dataChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(private ticketService: TicketService, private gameTicketQuery: GameTicketQuery) {}

  ngOnInit() {
    this.ticketService.resetSelectedTickets();
    this.games$ = this.gameTicketQuery.selectGamesWithTickets();
  }
}
